import { Box, Stack, Typography } from '@mui/material';

interface LogoProps {
  size?: number;
  showText?: boolean;
  variant?: 'full' | 'mark';
  color?: string;
  subtitleColor?: string;
}

/**
 * Sjednocene logo s hasicionline.cz - cervena ohnivka + nazev sluzby.
 */
export const Logo = ({
  size = 56,
  showText = true,
  variant = 'full',
  color,
  subtitleColor,
}: LogoProps) => {
  const mark = (
    <Box
      component="img"
      src="/img/logo.svg"
      alt="HasičiOnline"
      sx={{ width: size, height: size, display: 'block' }}
    />
  );

  if (variant === 'mark' || !showText) return mark;

  // Pokud je hlavni text bily (na cervenem pozadi), subtitle dostane stejnou ale lehce pruhlednou
  const resolvedSubtitle = subtitleColor ?? (color === '#FFFFFF' ? 'rgba(255,255,255,0.85)' : 'primary.main');

  const titleFontSize = size >= 96 ? '2rem' : size >= 72 ? '1.6rem' : size > 40 ? '1.05rem' : '0.9rem';
  const subtitleFontSize = size >= 96 ? '1.1rem' : size >= 72 ? '0.9rem' : size > 40 ? '0.65rem' : '0.6rem';
  const subtitleLetter = size >= 72 ? 3 : 1;

  return (
    <Stack direction="row" spacing={size >= 72 ? 1.25 : 0.5} alignItems="center">
      {mark}
      <Box>
        <Typography
          variant="h6"
          component="span"
          sx={{
            display: 'block',
            fontWeight: 700,
            fontSize: titleFontSize,
            lineHeight: 1.1,
            color: color ?? 'text.primary',
          }}
        >
          HasičiOnline.cz
        </Typography>
        <Typography
          variant="caption"
          sx={{
            display: 'block',
            fontSize: subtitleFontSize,
            letterSpacing: subtitleLetter,
            color: resolvedSubtitle,
            fontWeight: 800,
          }}
        >
          SOUTĚŽE
        </Typography>
      </Box>
    </Stack>
  );
};
